import type { ComponentProps } from "react";
import { useState } from "react";
import { Input, SearchIcon } from "@ptsd/uikit";
import { View } from "tamagui";

type SearchInputProps = ComponentProps<typeof Input>;

export const SearchInput: React.FC<SearchInputProps> = (props) => {
  const [isIconHidden, setIconHidden] = useState(false);
  return (
    <View position="relative" width="100%" flex={1}>
      {!isIconHidden && (
        <View position="absolute" left={10} top={6} zIndex={1}>
          <SearchIcon />
        </View>
      )}
      <Input
        onFocus={() => setIconHidden(true)}
        onBlur={() => setIconHidden(false)}
        focusStyle={{
          paddingHorizontal: "$2",
        }}
        borderRadius={"$4"}
        height={"$5.2"}
        variant="stacked"
        paddingLeft={"$4"}
        size={"sm"}
        {...props}
      />
    </View>
  );
};
